import React, { useEffect } from "react";
import closelogo from "../../images/cerrar.png"
import './projectDetails.css'

const ProjectDetails = (props) => {

    useEffect(()=>{
        console.log(props.project)
    },[])

    return(
        <div className="projectDetails">
            <div>
                <div className="header">
                    <div>
                        <p>{props.project.name}</p>
                        <img src={closelogo} alt="" onClick={()=>{props.setProject("")}}/>
                    </div>
                </div>
                <div className="imgContainer">
                    <img src={props.project.img} alt="" />
                </div>
            </div>
            <div className="description">
                <p>{props.project.description}</p>
                {
                props.project.link && <a href={props.project.link} target="_blank">Ver página</a>
                }
            </div>

        </div>
    )
}

export default ProjectDetails